import { grey } from '@material-ui/core/colors';
import { makeStyles, useTheme } from '@material-ui/core/styles';

export const Theme = useTheme;

export type ShowroomMediaItemStylesProps = {
	layerEnabled: boolean;
};

export const showroomImageLabelHeight = 25;

export const useStyles = makeStyles(theme => {
	return {
		previewMediaGridImg: {
			width: '100%',
			height: '100%',
			objectFit: 'cover',
			cursor: (props: ShowroomMediaItemStylesProps) => (props.layerEnabled ? 'pointer' : 'default'),
			WebkitUserSelect: 'none',
			MozUserSelect: 'none',
			userSelect: 'none',
			WebkitTouchCallout: 'none',
			WebkitTapHighlightColor: 'transparent'
		},
		container: {
			position: 'relative',
			display: 'flex',
			flexDirection: 'column',
			height: '100%'
		},
		previewLabel: {
			overflow: 'hidden',
			width: '100%',
			height: showroomImageLabelHeight,
			display: 'flex'
		},
		label: {
			width: '100%',
			textOverflow: 'ellipsis',
			color: grey[600],
			fontSize: 13,
			lineHeight: '25px',
			fontWeight: 500
		}
	};
});
